import Repository from '@/repositories/repository'

const EconomicCalendarRepository = {
  async getAllEconomicCalendarData(queryParams: any = {}) {
    const params = {
      page: '1',
      page_size: '200',
      ...queryParams
    }

    return await Repository('economic-calendar', 'page', params)
  }
}

export default EconomicCalendarRepository
